<template>
  <div style="       width: 23.49%;
          height: calc(100vh - 80px);
          position: absolute;
          right: 10px;
          top: 60px;" >
    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <p class="card-title">
        <img src="../assets/titleL.png" alt="" />&nbsp;{{ oneTitle }}&nbsp;<img
          src="../assets/titleR.png"
          alt=""
      />

      </p>

      <div class="recycle-record">
        <div class="recycle-record-title">
          <div style="width: 50%; float: left; text-align: center">
            模型名称
          </div>
          <div style="width: 50%; float: left; text-align: center">模型标识</div>
          <div style="width: 50%; float: left; text-align: center">预测项目</div>
          <div style="width: 50%; float: left; text-align: center">模型说明</div>
        </div>
        <div class="recycle-record-content" ref="content2" @mouseenter="mEnter2" @mouseleave="mLeave2" >
          <div :style="{ transform: `translate(0px,-${scrollTop2}px)` }">
            <div
                class="recycle-record-content-line"
                v-for="(line, i) in model"
                :key="i"
            >
              <div
                  class="recycle-record-content-item"
                  :title="line.name"
                  style="width: 40%; float: left; text-align: center"
              >
                {{ line.name }}
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.key"
                  style="width: 40%; float: left; text-align: center"
              >
                {{ line.key }}
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.forecastItem"
                  style="width: 40%; float: left; text-align: center"
              >
                {{ line.forecastItem }}
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.description"
                  style="width: 40%; float: left; text-align: center"
              >
                {{ line.description }}
              </div>
            </div>
            <div v-html="copyHtml2"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 0px"></div>

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <div class="card-title" style="width: 100%; float: left">
        <img src="../assets/titleL.png" />&nbsp;区域需水预测&nbsp;
        <img src="../assets/titleR.png" />
      </div>

      <div style="width: 100%; height: calc(100% - 10px)">
        <div id="forecastChart" style="width: 100%; height: 100%"></div>
      </div>

    </div>

    <div style="width: 100%; height: 0px"></div>

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <p class="card-title">
        <img src="../assets/titleL.png" alt="" />&nbsp;{{ twoTitle }}&nbsp;<img
          src="../assets/titleR.png"
          alt=""
      />

      </p>
<!--      <div class="button" style="margin-top: 20px;margin-right: 20px" @click="addScheme">-->
<!--        <span>新增</span>-->
<!--      </div>-->
      <div class="recycle-record">
        <div class="recycle-record-title">
          <div style="width: 19%; float: left; text-align: center">
            名称
          </div>
          <div style="width: 20%; float: left; text-align: center">断面</div>
          <div style="width: 20%; float: left; text-align: center">尺度</div>
          <div style="width: 20%; float: left; text-align: center">等级</div>
          <div style="width: 30%; float: left; text-align: center">自动预报</div>
          <div style="width: 30%; float: left; text-align: center">操作
          </div>
        </div>
        <div class="recycle-record-content" ref="content" @mouseenter="mEnter" @mouseleave="mLeave">
          <div :style="{ transform: `translate(0px,-${scrollTop}px)` }">
            <div
                class="recycle-record-content-line"
                v-for="(line, i) in dryForecast"
                :key="i"
            >
              <div
                  class="recycle-record-content-item"
                  :title="line.name"
                  style="width: 18%; float: left; text-align: center"
              >

                {{ line.name }}

              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.planStnm"
                  style="width: 14%; float: left; text-align: center"
              >
                {{ line.planStnm }}
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.type"
                  style="width: 15%; float: left; text-align: center"
              >
                {{ line.type }}
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.accuracyClass"
                  style="width: 24%; float: left; text-align: center"
              >
                <el-tag
                    :type="line.accuracyClass=='甲'?'success':'danger'"
                    effect="dark">
                  {{ line.accuracyClass }}
                </el-tag>
              </div>
              <div
                  class="recycle-record-content-item"
                  :title="line.description"
                  style="width: 10%; float: left; text-align: center"
              >
                <el-switch
                    v-model="line.description"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
              </div>
              <div class="button1" style="margin-left: 40px"  @click="clickForecast(line.number)">
                <span >预报</span>
              </div>
              <div class="button1"style="margin-left:2px"  @click="showFlow" >
                <span >预演</span>
              </div>
            </div>
            <div v-html="copyHtml"></div>
          </div>
        </div>
      </div>
    </div >

    <div style="width: 100%; height: 0px"></div>

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <p class="card-title">
        <img src="../assets/titleL.png" alt="" />&nbsp;{{ threeTitle }}&nbsp;<img
          src="../assets/titleR.png"
          alt=""
      />

      </p>
      <div class="recycle-record">
        <div class="recycle-record-title1">
          <div style="width: 53%; float: left; text-align: center">工程措施
            <div>
              <div style="width: 25%;float: left">方案</div><div style="width: 25%;float: left">闸门</div><div style="width: 25%;float: left">河道</div><div style="width: 15%;float: left">泵站</div>
            </div>

          </div>
          <div style="width: 47%; float: left; text-align: center">非工程措施
            <div>
              <div style="width: 30%;float: left">推送</div><div style="width: 30%;float: left">设备</div><div style="width: 40%;float: left">责任人</div>
            </div>

          </div>

        </div>
        <div class="recycle-record-content" style="height: calc(100% - 45px);" ref="content1" @mouseenter="mEnter1" @mouseleave="mLeave1">
          <div :style="{ transform: `translate(0px,-${scrollTop1}px)` }">
            <div class="recycle-record-content-line" v-for="(line, i) in recycleRecordsT" :key="i" @click="addDuty">
              <div class="recycle-record-content-item" :title="line.year"
                   style="width: 40%; float: left; text-align: center">
                {{ line.name }}
              </div>
              <div class="recycle-record-content-item" :title="line.site"
                   style="width: 20%; float: left; text-align: center">
                {{ line.gate }}
              </div>
              <div class="recycle-record-content-item" :title="line.level"
                   style="width: 30%; float: left; text-align: center">
                {{ line.river }}
              </div>
              <div class="recycle-record-content-item" :title="line.flow"
                   style="width: 33%; float: left; text-align: center">
                {{ line.station }}
              </div>
              <div style="border-left: 2px #00F2F8 dashed;height: 20px"></div>
              <div class="recycle-record-content-item" :title="line.flow"
                   style="width: 40%; float: left; text-align: center">
                {{ line.submit }}
              </div>
              <div class="recycle-record-content-item" :title="line.flow"
                   style="width: 30%; float: left; text-align: center">
                {{ line.equip }}
              </div>
              <div class="recycle-record-content-item" :title="line.area"
                   style="width: 40%; float: left; text-align: center">
                {{ line.duty }}
              </div>
            </div>
            <div v-html="copyHtml1"></div>
          </div>
        </div>

        <!-- <el-pagination background={ture} layout="prev, pager, next" :total="100" size-change="pageClick" class="paginationStyle"> </el-pagination> -->
      </div>
    </div>


    <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
          <span slot="title" style="color:#fff;font-size: 18px;float: left">
            　　添加责任人
          　　</span>
      <span style="color: #00F2F8">责任人：</span>
      <el-input size="medium" style="width: 200px"  v-model="value"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false,value=''">取 消</el-button>
        <el-button class="blue-button"  @click="dialogVisible = false,value=''">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import rightMenu from "@/components/rightMenu.vue";
let timer=null;
let timer1=null;
let timer2=null;
export default {
  name: "rightBoard",
  components:{rightMenu},
  data() {
    return {
      oneTitle: "专业模型管理 ",
      twoTitle: "来水预测方案 ",
      threeTitle:"调度预演方案",
      dialogVisible:false,
      value:'',
      menu: {
        visible: false,
        position: {
          clientX: 0,
          clientY: 0
        }
      },
      forecastData: [
        {
          area: "区域1",
          values: [120, 130, 128, 140, 150, 155, 160],
        },
        {
          area: "区域1",
          values: [90, 95, 100, 110, 115, 118, 120],
        },
        {
          area: "区域1",
          values: [60, 65, 70, 80, 85, 90, 95],
        },
      ],
      waterQuality: [
        { name: "取水口A", section: "入口监测点", scale: "pH7.2 | NTU1.2 | DO8.5", level: "蓝", auto: true },
        { name: "调蓄水库北区", section: "北区断面", scale: "pH6.5 | NTU3.8 | DO6.2", level: "黄", auto: true },
        { name: "输水渠道三号段", section: "3号段", scale: "pH8.1 | NTU6.1 | DO4.3", level: "橙", auto: false },
        { name: "调蓄水库东区", section: "东区断面", scale: "pH9.0 | NTU8.3 | DO3.5", level: "红", auto: false }
      ],
      qualityScrollTop: 0,
      copyQualityHtml: "",
      qualityTimer: null,
      model: [
        {
          "name": "ABC 水文模型",
          "key": "ABC",
          "forecastItem": "降雨径流关系 | 径流总量 | 暴雨洪峰预测",
          "description": "ABC 水文模型是一类基于前期条件(Antecedent Conditions) 的概念性水文模型，通过引入土壤含水量、前期降雨指数等因子动态调整产流能力，实现更符合实际的降雨径流过程模拟。模型步骤包括：(1) 计算前期湿润度指标；(2) 根据湿润度动态调整产流系数；(3) 构建快流与慢流的生成与汇流方程；(4) 利用历史资料进行参数率定与验证。模型结构简单但能有效反映流域湿润与响应特征，在暴雨径流模拟中表现良好。"
        },
        {
          "name": "GR4J 概念性水文模型",
          "key": "GR4J",
          "forecastItem": "日径流 | 枯季基流 | 暴雨径流",
          "description": "GR4J 是一种轻量级、四参数的概念性水文模型，通过土壤湿度储槽、产流储槽和汇流单元模拟降雨向径流的转换过程。模型优点为参数少、精度高、适应性强。建模步骤包括：(1) 根据降雨、蒸发数据驱动模型；(2) 对储槽参数进行率定；(3) 使用两条汇流路径模拟快流与慢流；(4) 输出日尺度径流过程。常用于实时预报和中短期径流模拟。"
        },
        {
          "name": "自回归滑动平均模型",
          "key": "ARIMA",
          "forecastItem": "平均流量 | 年径流总量 | 枯季流量 | 汛期径流过程",
          "description": "ARIMA 模型通过对径流时间序列的自相关特征进行建模，适用于缺乏气象数据或多影响因子难以量化的流域径流预测场景。建模流程包括：(1) 对序列进行平稳性检验与差分处理；(2) 通过 AIC 准则选择最优 p、d、q 结构；(3) 利用历史序列估计参数；(4) 输入新时段数据进行滚动预测。ARIMA 模型无需外部气象因子即可进行预测，适用于长期序列的统计规律性分析和短期预报。"
        },
        {
          "name": "NSGA-II 水库调度优化模型",
          "key": "NSGA2",
          "forecastItem": "发电收益 | 防洪库容保障率 | 供水可靠性 | 综合调度策略",
          "description": "NSGA-II 是一种快速非支配排序遗传算法，可同时优化多种相互冲突的目标函数，如水库发电、防洪、生态流量和供水保障等。模型主要步骤包括：(1) 构建多目标函数与约束条件；(2) 生成初始调度策略种群；(3) 通过快速非支配排序与拥挤度距离筛选优质解；(4) 采用交叉与变异产生新一代调度方案；(5) 得到 Pareto 最优调度曲线群。NSGA-II 适合解决大规模、非线性、约束复杂的调度优化问题，在水库群联合调度中广泛应用。"
        },
        {
          "name": "SAC-SMA 分布式土壤湿度模型",
          "key": "SAC-SMA",
          "forecastItem": "流域湿度状态 | 洪峰流量 | 径流过程",
          "description": "SAC-SMA 是美国国家气象局的核心降雨径流模型，通过多层土壤湿度储层模拟产流过程，适用于湿润与半湿润区的降雨径流预报。模型包括：(1) 上层与下层土壤湿润度模块；(2) 两条径流路径（快流、慢流）；(3) 蒸散、水量平衡控制方程。通过率定土壤容量参数，可实现对暴雨洪水过程的准确预测。"
        },
        {
          "name": "新安江三水源模型",
          "key": "XAJ",
          "forecastItem": "暴雨洪水 | 径流分割 | 基流模拟",
          "description": "新安江模型以张伯声三水源理论为基础，将产流划分为蒸散补给、地表径流、壤中流和地下径流。模型采用三层蒸散、蓄水容量曲线、自由水蓄水库等结构，适用于湿润季风区。流程包括：(1) 根据雨量与蒸散计算产流；(2) 各类径流经汇流模块处理；(3) 输出流域出流过程。模型特别适合东南湿润地区。"
        },
        {
          name: "自回归滑动平均模型",
          key: "ARIMA",
          forecastItem:"平均流量 | 枯季径流总量",
          description:"影响径流的水文气象因素较多, 要建立较为复杂的、考虑到诸多因素的预测模型, 变得非常困难，自回归滑动平均模型在径流预测应用能够较好解决这样的问题，通过建立结构简单又能反映流域时变特征的ARMA (p, q) 水文预报模型。利用现有的径流资料，通过最小信息准则 (AIC) ,确定模型的最佳阶数, 采用实时校正的可变遗忘因子递推最小二乘法, 依据历史资料对该模型进行了验证。自回归滑动平均模型基于历史径流序列建模：1. 设定模型p、q参数值确定模型最优结构；2.然后设定优化函数，不断计算确定各个滞时的最优权重，从而得到序列拟合结果；3.最后通过不断输入新数据得到下一个时段的预测值。"
        },
        {
          "name": "水资源供需平衡计算模型",
          "key": "SupplyDemand",
          "forecastItem": "区域供水能力 | 用水需求预测 | 年度水资源缺口",
          "description": "供需平衡模型通过对不同供水来源（地表水、地下水、调水工程等）与用水部门（农业、工业、生活、生态）进行定量评估，计算未来时段的水资源供需差额，为区域水资源规划与调度提供基础。模型包含：(1) 对未来用水需求进行预测；(2) 评估可供水量（结合工程能力与水文预测）；(3) 构建供需平衡方程；(4) 得到缺水量或富余水量；(5) 可进一步嵌入调度模型进行优化配置。该模型可用于年度/季度水资源评估与规划研究。"
        }
      ],
      recycleRecordsT: [
        {
          name:'逐步多元回归模型-枯季径流总量方案',
          gate:'2',
          river:'河口庙',
          station:'张家卯',
          submit:"已推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'逐步多元回归模型-枯季径流总量方案',
          gate:'2',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-年径流总量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"已推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-枯季径流总量方案',
          gate:'4',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'自回归滑动平均模型-平均流量方案',
          gate:'2',
          river:'河口庙',
          station:'张家卯',
          submit:"已推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },{
          name:'多元回归模型-秋汛期最大流量方案',
          gate:'3',
          river:'河口庙',
          station:'张家卯',
          submit:"未推送",
          equip:'未知',
          duty:'张三',
        },
      ],
      forecast:[],

      dryForecast: [
        {
          name: "单模型-枯季径流总量",
          number:1,
          planStnm: "龙门",
          type:"年",
          accuracyClass:"甲1",
          description:true
        },
        {
          name: "多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲2",
          description:false
        },
        {
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"乙",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"乙",
          description:false
        },{
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"乙",
          description:false
        },{
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
        {
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "单模型-枯季径流总量",
          planStnm: "龙门",
          number:1,
          type:"年",
          accuracyClass:"甲",
          description:false
        },{
          name: "逐步多元回归模型-枯季径流总量",
          planStnm: "龙门",
          number:2,
          type:"年",
          accuracyClass:"甲",
          description:false
        },
      ],
      scrollTop: 0, //列表滚动高度
      scrollTop1: 0, //列表滚动高度
      scrollTop2:0,
      speed: 15,
      copyHtml:'',
      copyHtml1:"",
      copyHtml2:'',
      fullscreenLoading: false
    };
  },
  mounted() {
    this.initFQWSJ();
    this.initForecastChart();
    // window.addEventListener("resize", () => {
    // 	this.$echarts.init(document.getElementById("fqwsj")).resize();
    // });
  },
  destroyed() {
    this.destroyInterval()
  },
  methods: {
    initFQWSJ() {
      this.forecast = this.dryForecast
      this.initScroll()
      this.initScroll1()
      this.initScroll2()
    },
    scroll3() {
      const content = this.$refs.qualityScroll;
      const scrollContent = content.querySelector('.table-data');

      if (scrollContent.clientHeight > content.clientHeight) {
        scrollContent.innerHTML += scrollContent.innerHTML;

        let offset = 0;
        const speed = 30;

        setInterval(() => {
          offset++;
          if (offset >= scrollContent.scrollHeight / 2) {
            offset = 0;
          }
          content.scrollTop = offset;
        }, speed);
      }
    },

    initScroll() {
      this.$nextTick(() => {
        this.copyHtml = this.$refs.content.innerHTML
        this.startScroll()
      })
    },
    initScroll1() {
      this.$nextTick(() => {
        this.copyHtml1 = this.$refs.content1.innerHTML
        this.startScroll1()
      })
    },
    initScroll2() {
      this.$nextTick(() => {
        this.copyHtml2 = this.$refs.content2.innerHTML
        this.startScroll2()
      })
    },
    initForecastChart() {
      const chartDom = document.getElementById("forecastChart");
      if (!chartDom) return;

      const myChart = echarts.init(chartDom);

      // 新的颜色体系（大屏渐变主题）
      const colorList = [
        "#4B9CFF",
        "#00D2FF",
        "#3DE1AD",
        "#F6C945",
        "#FF8F6A",
        "#DD5DFE",
        "#5C7CFA",
        "#76E2F4",
        "#9AFFA7",
      ];

      // 额外生成几条预测曲线（示例）
      const enhancedData = [
        ...this.forecastData,
        { area: "区域4", values: [130, 140, 150, 160, 170, 180, 190] },
        { area: "区域5", values: [100, 110, 108, 115, 120, 130, 135] },
        { area: "区域6", values: [80, 85, 90, 92, 100, 105, 108] },
      ];

      // 构建多条线 + 渐变面积
      const series = enhancedData.map((item, index) => ({
        name: item.area,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        data: item.values,
        lineStyle: {
          width: 3,
          color: colorList[index % colorList.length],
          shadowBlur: 15,
          shadowColor: colorList[index % colorList.length],
        },
        itemStyle: {
          color: "#fff",
          borderColor: colorList[index % colorList.length],
          borderWidth: 3,
        },
        areaStyle: {
          opacity: 0.25,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: colorList[index % colorList.length],
            },
            {
              offset: 1,
              color: "rgba(0,0,0,0)",
            },
          ]),
        },
      }));

      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderWidth: 0,
          textStyle: { color: "#fff", fontSize: 14 },
          padding: 10,
        },

        legend: {
          data: enhancedData.map((i) => i.area),
          bottom: 0,
          textStyle: { color: "#fff", fontSize: 12 },
          icon: "circle",
        },

        grid: {
          top: "35%",
          left: "5%",
          right: "6%",
          bottom: "10%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          data: this.forecastDays,
          boundaryGap: false,
          axisLine: {
            lineStyle: { color: "rgba(255,255,255,0.45)" },
          },
          axisLabel: { color: "#fff", fontSize: 12 },
        },

        yAxis: {
          type: "value",
          axisLine: { lineStyle: { color: "rgba(255,255,255,0.45)" } },
          axisLabel: { color: "#fff", fontSize: 12 },
          splitLine: {
            lineStyle: { color: "rgba(255,255,255,0.1)" },
          },
        },

        series: series,
      };

      myChart.setOption(option);
    },
    // 鼠标移入停止滚动
    mEnter() {
      clearInterval(timer);
    },
    // 鼠标移出继续滚动
    mLeave() {
      this.startScroll()
    },
    mEnter1() {
      clearInterval(timer1);
    },
    // 鼠标移出继续滚动
    mLeave1() {
      this.startScroll1()
    },
    mEnter2() {
      clearInterval(timer2);
    },
    // 鼠标移出继续滚动
    mLeave2() {
      this.startScroll2()
    },
    // 开始滚动
    startScroll() {
      timer = setInterval(this.scroll, this.speed);
    },
    startScroll1() {
      timer1 = setInterval(this.scroll1, this.speed);
    },
    startScroll2() {
      timer2 = setInterval(this.scroll2, this.speed);
    },
    // 滚动处理方法
    scroll() {
      this.scrollTop++
      // 获取需要滚动的盒子的高度
      let scrollItemBox = this.$refs.content.offsetHeight
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if (this.scrollTop >= scrollItemBox) {
        this.scrollTop = 0
      }
    },
    scroll1() {
      this.scrollTop1++
      // 获取需要滚动的盒子的高度
      let scrollItemBox1 = this.$refs.content1.offsetHeight
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if (this.scrollTop1 >= scrollItemBox1) {
        this.scrollTop1 = 0
      }
    },
    scroll2() {
      this.scrollTop2++
      // 获取需要滚动的盒子的高度
      let scrollItemBox2 = this.$refs.content2.offsetHeight
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if (this.scrollTop2 >= scrollItemBox2) {
        this.scrollTop2 = 0
      }
    },
    destroyInterval(){
      clearInterval(timer);
      clearInterval(timer1);
      clearInterval(timer2);
    },
    addScheme(){
      this.$emit('changeFlag')
    },


    clickForecast(num){
      const loading = this.$loading({
        lock: true,
        text: '预报结果计算中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        this.$emit('changeScheme',num)
      }, 2000);
    },
    showFlow(){
      this.$emit('doDispatch')
    },
    addDuty(){
      this.dialogVisible=true
    },
    handleClose(done){
      this.value=''
      done()
    },
    addModel(){
      this.$emit('addModel',true)
    }
  },


};
</script>

<style scoped >



/deep/.el-dialog,
.el-pager li {
  background-color: rgba(30, 144 ,255, 0.0);
  background-image: url(../assets/twoR.png);
  background-size: 100%  100%;
}

::v-deep .el-input__inner {
  border: 1px solid #00F2F8;
  background-color: transparent !important;
}
.blue-button {
  background-color:  #00F2F8;
}
</style>


